import { fetchDataAndProceed } from '../../config/utils'
import { METHOD_TYPES } from '../../config/constants'

export const getAccuracyFilters = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/nlp/modelAccuracyFilters', METHOD_TYPES.GET, data, callback)
}

export const getIntentsTableData = (data, callback) => { //Large timeout because this api can take a long time with 'utterance' filter
    return fetchDataAndProceed('/admin/v1/nlp/nlpAccuracy', METHOD_TYPES.GET, data, callback, 200000)
}

export const makeApiCall = (url, method, data, callback) => fetchDataAndProceed(url, method, data, callback)


// WEBPACK FOOTER //
// ./src/data/redux/model_accuracy_details/api.js